<app-sidebar-input [itemsInnerComponent]="itemsInnerComponent()" />
<app-sidebar-input-close />
